import { DataTable } from "@/components/admin/data-table";
import { List } from "@/components/admin/list";

import { leadStatusChoices } from "../contacts/leadModel";
import type { LeadSubmission } from "../types";
import { leadListFilters } from "./LeadListFilter";

const fullName = (first?: string | null, last?: string | null) =>
  [first, last].filter(Boolean).join(" ");

/** Read-only list of website form submissions, newest first. */
export const LeadList = () => (
  <List
    resource="lead_submissions"
    filters={leadListFilters}
    actions={false}
    sort={{ field: "submitted_at", order: "DESC" }}
    perPage={25}
    exporter={false}
  >
    <DataTable
      bulkActionButtons={false}
      rowClick={(_id, _resource, record) =>
        `/contacts/${record.contact_id}/show`
      }
    >
      <DataTable.Col
        source="submitted_at"
        label="resources.lead_submissions.fields.submitted_at"
        render={(record: LeadSubmission) =>
          new Date(record.submitted_at).toLocaleString()
        }
      />
      <DataTable.Col
        source="form_type"
        label="resources.lead_submissions.fields.form_type"
      />
      <DataTable.Col
        source="contact_last_name"
        label="resources.lead_submissions.fields.name"
        render={(record: LeadSubmission) =>
          fullName(record.contact_first_name, record.contact_last_name)
        }
      />
      <DataTable.Col
        source="company_name"
        label="resources.lead_submissions.fields.company"
      />
      <DataTable.Col
        source="interest"
        label="resources.lead_submissions.fields.interest"
      />
      <DataTable.Col
        source="sales_last_name"
        label="resources.lead_submissions.fields.sales_id"
        render={(record: LeadSubmission) =>
          fullName(record.sales_first_name, record.sales_last_name)
        }
      />
      <DataTable.Col
        source="contact_status"
        label="resources.lead_submissions.fields.contact_status"
        render={(record: LeadSubmission) =>
          leadStatusChoices.find((s) => s.value === record.contact_status)
            ?.label ?? record.contact_status
        }
      />
    </DataTable>
  </List>
);
